// IIC Codes - Italian Labels Mapping
// Mappatura dei codici IIC con le etichette in italiano per bilanci aziendali

const IIC_CODES_IT = {
  // STATO PATRIMONIALE - ATTIVO
  
  // Crediti verso soci
  "IIC001": "Crediti verso soci",
  "IIC002": "Crediti verso soci parte da richiamare",
  "IIC193": "Crediti verso soci parte richiamata",

  // B. IMMOBILIZZAZIONI
  
  // B.I. Immobilizzazioni immateriali
  "IIC003": "Costi di impianto e di ampliamento",
  "IIC004": "Costi di ricerca, sviluppo e pubblicità",
  "IIC005": "Diritti di brevetto industriale",
  "IIC006": "Concessioni, licenze, marchi",
  "IIC007": "Avviamento",
  "IIC008": "Immobilizzazioni in corso e acconti",
  "IIC009": "Altre immobilizzazioni immateriali",
  "IIC010": "Fondo ammortamento immobilizzazioni immateriali",
  "IIC011": "Totale immobilizzazioni immateriali",

  // B.II. Immobilizzazioni materiali
  "IIC012": "Terreni e fabbricati",
  "IIC013": "Impianti e macchinari",
  "IIC014": "Attrezzature industriali e commerciali",
  "IIC015": "Altri beni",
  "IIC016": "Immobilizzazioni in corso e acconti",
  "IIC017": "Fondo ammortamento immobilizzazioni materiali",
  "IIC018": "Totale immobilizzazioni materiali",

  // B.III. Immobilizzazioni finanziarie
  "IIC019": "Partecipazioni in imprese controllate",
  "IIC020": "Partecipazioni in imprese collegate",
  "IIC021": "Partecipazioni in imprese controllanti",
  "IIC022": "Partecipazioni in altre imprese",
  "IIC023": "Totale partecipazioni",
  "IIC024": "Crediti verso imprese controllate",
  "IIC025": "Crediti verso imprese controllate oltre esercizio",
  "IIC026": "Crediti verso imprese collegate",
  "IIC027": "Crediti verso imprese collegate oltre esercizio",
  "IIC028": "Crediti verso controllanti",
  "IIC029": "Crediti verso controllanti oltre esercizio",
  "IIC030": "Crediti verso altri",
  "IIC031": "Crediti verso altri oltre esercizio",
  "IIC032": "Crediti finanziari a breve termine",
  "IIC033": "Crediti finanziari a lungo termine",
  "IIC034": "Altri titoli",
  "IIC035": "Strumenti finanziari derivati attivi",
  "IIC036": "Attività finanziarie per la gestione accentrata",
  "IIC037": "Rettifiche ad attività finanziarie",
  "IIC038": "Totale immobilizzazioni finanziarie",
  
  "IIC039": "Totale immobilizzazioni",

  // C. ATTIVO CIRCOLANTE
  
  // C.I. Rimanenze
  "IIC040": "Materie prime, sussidiarie e di consumo",
  "IIC041": "Prodotti in corso di lavorazione e semilavorati",
  "IIC042": "Lavori in corso su ordinazione",
  "IIC043": "Prodotti finiti e merci",
  "IIC044": "Acconti",
  "IIC045": "Totale rimanenze",
  "IIC349": "Immobilizzazioni materiali destinate alla vendita",

  // C.II. Crediti
  "IIC046": "Crediti verso clienti",
  "IIC047": "Crediti verso clienti oltre esercizio",
  "IIC048": "Crediti verso imprese controllate",
  "IIC049": "Crediti verso imprese controllate oltre esercizio",
  "IIC050": "Crediti verso imprese collegate",
  "IIC051": "Crediti verso imprese collegate oltre esercizio",
  "IIC052": "Crediti verso controllanti",
  "IIC053": "Crediti verso controllanti oltre esercizio",
  "IIC054": "Crediti tributari",
  "IIC055": "Crediti tributari oltre esercizio",
  "IIC056": "Imposte anticipate",
  "IIC057": "Imposte anticipate oltre esercizio",
  "IIC058": "Crediti verso altri",
  "IIC327": "Crediti verso altri oltre esercizio",

  // C.III. Attività finanziarie non immobilizzate
  "IIC059": "Partecipazioni in imprese controllate",
  "IIC060": "Partecipazioni in imprese collegate",
  "IIC061": "Partecipazioni in imprese controllanti",
  "IIC062": "Altre partecipazioni",
  "IIC065": "Strumenti finanziari derivati attivi",
  "IIC066": "Altri titoli",
  "IIC200": "Partecipazioni in imprese sottoposte al controllo delle controllanti",
  "IIC201": "Strumenti finanziari derivati attivi",
  "IIC202": "Attività finanziarie per la gestione accentrata",

  // C.IV. Disponibilità liquide
  "IIC069": "Depositi bancari e postali",
  "IIC070": "Denaro e valori in cassa",
  "IIC071": "Totale disponibilità liquide",

  "IIC072": "Totale attivo circolante",

  // D. RATEI E RISCONTI ATTIVI
  "IIC073": "Ratei e risconti attivi",
  "IIC074": "Totale attivo",

  // STATO PATRIMONIALE - PASSIVO

  // A. PATRIMONIO NETTO
  "IIC075": "Capitale sociale",
  "IIC076": "Riserva da soprapprezzo azioni",
  "IIC077": "Riserve di rivalutazione",
  "IIC078": "Riserva legale",
  "IIC079": "Riserve statutarie",
  "IIC080": "Altre riserve",
  "IIC081": "Riserva per operazioni di copertura dei flussi finanziari attesi",
  "IIC082": "Utili (perdite) portati a nuovo",
  "IIC083": "Utile (perdita) dell'esercizio",
  "IIC084": "Totale patrimonio netto",
  "IIC203": "Riserva straordinaria",
  "IIC204": "Riserve da deroghe ex art. 2423 c.c.",
  "IIC205": "Riserva azioni proprie",
  "IIC206": "Riserva da rivalutazione delle partecipazioni",
  "IIC207": "Versamenti in conto aumento capitale",
  "IIC208": "Versamenti in conto futuro aumento capitale",
  "IIC209": "Versamenti in conto capitale",
  "IIC210": "Versamenti a copertura perdite",
  "IIC211": "Riserva da riduzione capitale sociale",
  "IIC212": "Riserva avanzo di fusione",
  "IIC213": "Riserva per utili su cambi non realizzati",
  "IIC214": "Riserve diverse",
  "IIC215": "Azioni proprie in portafoglio",
  "IIC216": "Utile (perdita) portata a nuovo",
  "IIC217": "Dividendi in acconto",
  "IIC218": "Copertura perdite",
  "IIC345": "Riserva negativa per azioni proprie",

  // B. FONDI PER RISCHI E ONERI
  "IIC085": "Fondi per trattamento di quiescenza",
  "IIC086": "Fondi per imposte",
  "IIC087": "Strumenti finanziari derivati passivi",
  "IIC088": "Altri fondi",
  "IIC089": "Totale fondi per rischi e oneri",
  "IIC219": "Fondo per imposte differite",

  // C. TRATTAMENTO DI FINE RAPPORTO
  "IIC090TFR": "Trattamento di fine rapporto",

  // D. DEBITI
  "IIC090": "Obbligazioni",
  "IIC091": "Obbligazioni oltre esercizio",
  "IIC092": "Obbligazioni convertibili",
  "IIC093": "Obbligazioni convertibili oltre esercizio",
  "IIC094": "Debiti verso soci per finanziamenti",
  "IIC095": "Debiti verso soci oltre esercizio",
  "IIC096": "Debiti verso banche",
  "IIC097": "Debiti verso banche oltre esercizio",
  "IIC098": "Debiti verso altri finanziatori",
  "IIC099": "Debiti verso altri finanziatori oltre esercizio",
  "IIC100": "Acconti",
  "IIC101": "Acconti oltre esercizio",
  "IIC102": "Debiti verso fornitori",
  "IIC103": "Debiti verso fornitori oltre esercizio",
  "IIC104": "Debiti rappresentati da titoli di credito",
  "IIC105": "Debiti rappresentati da titoli oltre esercizio",
  "IIC106": "Debiti verso imprese controllate",
  "IIC107": "Debiti verso imprese controllate oltre esercizio",
  "IIC108": "Debiti verso imprese collegate",
  "IIC109": "Debiti verso imprese collegate oltre esercizio",
  "IIC110": "Debiti verso controllanti",
  "IIC111": "Debiti verso controllanti oltre esercizio",
  "IIC112": "Debiti verso imprese sottoposte al controllo delle controllanti",
  "IIC113": "Debiti verso imprese sottoposte oltre esercizio",
  "IIC114": "Debiti tributari",
  "IIC115": "Debiti tributari oltre esercizio",
  "IIC116": "Debiti verso istituti di previdenza",
  "IIC117": "Debiti verso istituti di previdenza oltre esercizio",
  "IIC118": "Altri debiti",
  "IIC184": "Altri debiti oltre esercizio",
  "IIC185": "Altri debiti entro esercizio",
  "IIC119": "Totale debiti",
  "IIC329": "Debiti verso banche entro esercizio",
  "IIC330": "Debiti verso banche oltre esercizio",
  "IIC331": "Acconti entro esercizio",
  "IIC332": "Acconti oltre esercizio",
  "IIC333": "Debiti verso fornitori entro esercizio",
  "IIC334": "Debiti verso fornitori oltre esercizio",
  "IIC335": "Debiti verso imprese controllate entro esercizio",
  "IIC336": "Debiti verso imprese controllate oltre esercizio",
  "IIC337": "Debiti verso imprese collegate entro esercizio",
  "IIC338": "Debiti verso imprese collegate oltre esercizio",
  "IIC339": "Debiti verso controllanti entro esercizio",
  "IIC340": "Debiti verso controllanti oltre esercizio",
  "IIC341": "Debiti tributari entro esercizio",
  "IIC342": "Debiti tributari oltre esercizio",
  "IIC343": "Debiti verso istituti di previdenza entro esercizio",

  // E. RATEI E RISCONTI PASSIVI
  "IIC120": "Ratei e risconti passivi",
  "IIC121": "Totale passivo",

  // CONTO ECONOMICO

  // A. VALORE DELLA PRODUZIONE
  "IIC124": "Ricavi delle vendite e delle prestazioni",
  "IIC125": "Variazioni delle rimanenze di prodotti",
  "IIC126": "Variazioni dei lavori in corso su ordinazione",
  "IIC127": "Incrementi di immobilizzazioni per lavori interni",
  "IIC128": "Altri ricavi e proventi",
  "IIC129": "Contributi in conto esercizio",
  "IIC130": "Totale valore della produzione",
  "IIC186": "Ricavi diversi",
  "IIC223": "Proventi vari",

  // B. COSTI DELLA PRODUZIONE
  "IIC131": "Per materie prime, sussidiarie, di consumo e merci",
  "IIC132": "Per servizi",
  "IIC133": "Per godimento di beni di terzi",
  "IIC134": "Per il personale",
  "IIC135": "Salari e stipendi",
  "IIC136": "Oneri sociali",
  "IIC137": "Trattamento di fine rapporto",
  "IIC138": "Trattamento di quiescenza e simili",
  "IIC139": "Altri costi del personale",
  "IIC140": "Ammortamenti e svalutazioni",
  "IIC141": "Ammortamento delle immobilizzazioni immateriali",
  "IIC142": "Ammortamento delle immobilizzazioni materiali",
  "IIC143": "Altre svalutazioni delle immobilizzazioni",
  "IIC144": "Svalutazioni dei crediti",
  "IIC145": "Variazioni delle rimanenze di materie prime",
  "IIC146": "Accantonamenti per rischi",
  "IIC147": "Altri accantonamenti",
  "IIC148": "Oneri diversi di gestione",
  "IIC149": "Totale costi della produzione",
  "IIC187": "Costi diversi",
  "IIC188": "Altri oneri",

  // DIFFERENZA TRA VALORE E COSTI DELLA PRODUZIONE
  "IIC224": "Differenza tra valore e costi della produzione",

  // C. PROVENTI E ONERI FINANZIARI
  "IIC150": "Proventi da partecipazioni",
  "IIC152": "da imprese controllate",
  "IIC154": "da imprese collegate",
  "IIC155": "da imprese controllanti",
  "IIC156": "da altre imprese",
  "IIC158": "Altri proventi finanziari",
  "IIC159": "Totale proventi finanziari",
  "IIC189": "Proventi da titoli iscritti nelle immobilizzazioni",
  "IIC190": "Proventi da titoli iscritti nell'attivo circolante",
  "IIC225": "Interessi attivi da imprese controllate",
  "IIC226": "Interessi attivi da imprese collegate",
  "IIC227": "Interessi attivi da controllanti",
  "IIC228": "Interessi attivi da altri",
  "IIC229": "Altri proventi finanziari da controllate",
  "IIC230": "Altri proventi finanziari da collegate",
  "IIC231": "Altri proventi finanziari da controllanti",
  "IIC232": "Altri proventi finanziari da altri",
  "IIC233": "Interessi e altri oneri finanziari",
  "IIC234": "verso imprese controllate",
  "IIC235": "verso imprese collegate",
  "IIC236": "verso imprese controllanti",
  "IIC237": "verso altri",
  "IIC238": "Utili su cambi",
  "IIC239": "Perdite su cambi",
  "IIC240": "Utili e perdite su cambi",
  "IIC241": "Totale interessi e oneri finanziari",
  "IIC242": "Totale proventi e oneri finanziari",
  "IIC243": "Proventi diversi dai precedenti",
  "IIC244": "Altri proventi e oneri finanziari",
  "IIC161": "Totale proventi e oneri finanziari",

  // D. RETTIFICHE DI VALORE DI ATTIVITA' FINANZIARIE
  "IIC162": "Rivalutazioni",
  "IIC163": "di partecipazioni",
  "IIC164": "di immobilizzazioni finanziarie",
  "IIC165": "di titoli iscritti nell'attivo circolante",
  "IIC166": "di strumenti finanziari derivati",
  "IIC167": "Svalutazioni",
  "IIC168": "di partecipazioni",
  "IIC169": "di immobilizzazioni finanziarie",
  "IIC245": "di titoli iscritti nell'attivo circolante",
  "IIC246": "di strumenti finanziari derivati",
  "IIC170": "Totale delle rettifiche di valore",

  // RISULTATO PRIMA DELLE IMPOSTE
  "IIC177": "Risultato prima delle imposte",

  // IMPOSTE SUL REDDITO
  "IIC178": "Imposte sul reddito dell'esercizio",
  "IIC191": "Imposte correnti",
  "IIC192": "Imposte differite e anticipate",
  "IIC250": "Proventi da adesione al consolidato fiscale",
  "IIC347": "Oneri da adesione al consolidato fiscale",

  // UTILE (PERDITA) DELL'ESERCIZIO
  "IIC179": "Utile (perdita) dell'esercizio",

  // AGGREGATI E ALTRI CODICI
  "IIC352": "Accantonamento al fondo TFR",
  "IIC353": "Utilizzo del fondo TFR",
  "IIC354": "Accantonamenti ai fondi rischi",
  "IIC355": "Utilizzo fondi rischi",
  "IIC350": "Altri accantonamenti e rettifiche",
  "IIC351": "Altri utilizzi di fondi"
};

export default IIC_CODES_IT;

// Per ambienti CommonJS
if (typeof module !== 'undefined' && module.exports) {
  module.exports = IIC_CODES_IT;
}